export default "__VITE_ASSET__BhWJffkg__"